import { Layout } from 'antd';

import { Chatbot, HeaderApplication } from '@Components/index';
import mainBackground from '@Images/gradient-background.jpg';
import PageLayoutResolver from '../components/PageLayoutResolver';

import styles from './wrapper-desktop-page.module.css';

const WrapperDesktopPage: React.FC = () => {
  return (
    <Layout
      className={styles.container}
      style={{ backgroundImage: `url(${mainBackground})` }}
    >
      <Layout>
        <PageLayoutResolver>
          <HeaderApplication />
        </PageLayoutResolver>
      </Layout>
      <Chatbot />
    </Layout>
  );
};

export default WrapperDesktopPage;
